import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { RocketIcon, ShoppingBagIcon, MicIcon, HeartIcon, ArrowRightIcon } from 'lucide-react';
const programs = [{
  icon: RocketIcon,
  tag: 'Para emprendedores',
  title: 'Ruta Emprendedor',
  description: 'Para quienes están comenzando o se sienten estancados. Aquí construyes las bases: mentalidad, modelo de negocio, primeras ventas.',
  forWho: 'Emprendedores en inicio o en transición',
  learn: 'Modelo de negocio, propuesta de valor, primeras ventas, mentalidad de abundancia',
  results: 'Claridad total + primeros ingresos + base sólida'
}, {
  icon: ShoppingBagIcon,
  tag: 'Para vendedores online',
  title: 'Ruta Ecommerce',
  description: 'Para quienes quieren vender productos físicos o digitales online con sistemas que funcionan sin ti.',
  forWho: 'Emprendedores con producto o idea de producto',
  learn: 'Tienda online, tráfico, conversión, automatización, escalado',
  results: 'Tienda activa + ventas consistentes + sistema automatizado'
}, {
  icon: MicIcon,
  tag: 'Para creadores y expertos',
  title: 'Ruta Marca Personal',
  description: 'Para posicionarte como referente en tu industria y monetizar tu conocimiento, historia y presencia.',
  forWho: 'Coaches, consultores, creadores, expertos',
  learn: 'Posicionamiento, contenido estratégico, autoridad, monetización',
  results: 'Marca reconocida + audiencia comprometida + ingresos por conocimiento'
}, {
  icon: HeartIcon,
  tag: 'Trabajo interior',
  title: 'Alma en Expansión',
  description: 'El trabajo que ningún curso de negocios te enseña. Energía femenina, identidad, abundancia, sanación y expansión.',
  forWho: 'Quienes sienten que algo interno bloquea su exterior',
  learn: 'Identidad, energía, abundancia, sanación, propósito profundo',
  results: 'Alineación total + expansión interior + vida diseñada'
}];
export function Programs() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="programas" ref={ref} className="py-24 md:py-32 bg-cream" data-id="element-259">
      <div className="max-w-7xl mx-auto px-6" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-261">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-262">
            Programas
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-263">
            Elige tu Ruta
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-264">
            Cada camino está diseñado para donde estás ahora y hacia donde vas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-265">
          {programs.map((program, index) => <motion.div key={program.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: 'easeOut'
        }} className="group bg-white rounded-3xl p-8 lg:p-10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500" data-id="element-266">
              <div className="flex items-start gap-4 mb-6" data-id="element-267">
                <div className="w-14 h-14 rounded-2xl bg-beige flex items-center justify-center flex-shrink-0" data-id="element-268">
                  <program.icon className="w-7 h-7 text-gold" data-id="element-269" />
                </div>
                <div data-id="element-270">
                  <span className="inline-block px-3 py-1 bg-gold/10 text-gold text-xs font-medium rounded-full mb-2" data-id="element-271">
                    {program.tag}
                  </span>
                  <h3 className="font-serif text-2xl text-charcoal" data-id="element-272">
                    {program.title}
                  </h3>
                </div>
              </div>

              <p className="font-sans text-charcoal-mid mb-6 leading-relaxed" data-id="element-273">
                {program.description}
              </p>

              <div className="space-y-4 mb-8" data-id="element-274">
                <div data-id="element-275">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-276">
                    Para quién
                  </span>
                  <p className="font-sans text-sm text-charcoal mt-1" data-id="element-277">
                    {program.forWho}
                  </p>
                </div>
                <div data-id="element-278">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-279">
                    Qué aprenderás
                  </span>
                  <p className="font-sans text-sm text-charcoal mt-1" data-id="element-280">
                    {program.learn}
                  </p>
                </div>
                <div data-id="element-281">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-282">
                    Resultados
                  </span>
                  <p className="font-sans text-sm text-charcoal mt-1" data-id="element-283">
                    {program.results}
                  </p>
                </div>
              </div>

              <button className="inline-flex items-center gap-2 font-sans text-gold font-medium group-hover:gap-3 transition-all duration-300" data-id="element-284">
                Ver programa
                <ArrowRightIcon className="w-4 h-4" data-id="element-285" />
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}